var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnInvisible = function SvgIcnInvisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8h1.387C3.437 9.903 5.588 11.107 8 11.107c2.412 0 4.563-1.204 5.613-3.107H15a6.74 6.74 0 0 1-1.888 2.453l1.445 1.257c.245.213.218.53-.06.71-.277.178-.7.15-.945-.063l-1.41-1.226a7.928 7.928 0 0 1-1.855.79l.511 1.4c.11.3-.082.597-.428.665-.347.068-.716-.12-.826-.419l-.51-1.393a8.514 8.514 0 0 1-2.52-.068l-.535 1.461c-.11.3-.48.487-.826.42-.346-.069-.538-.367-.429-.666l.561-1.534a7.872 7.872 0 0 1-1.427-.656l-1.41 1.226c-.244.213-.668.24-.945.062-.278-.178-.305-.496-.06-.709l1.445-1.257A6.742 6.742 0 0 1 1 8Z",
    fill: "#292525"
  })));
};
export default SvgIcnInvisible;